import moment from 'moment';
import momenttime from 'moment-timezone';

// Backend storage: a DATE-TIME field is saved in GMT (real time); a DATE-only
// field is saved WITHOUT timezone (no time, or literal 00:00). So only a
// date-time value is shifted to the company/local timezone — a date-only value
// is a plain local calendar date and must never be shifted.
const MODEL_DATE_RE = /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}(:\d{2})?)?$/;

const isDateOnlyValue = (raw) => {
    const timeMatch = raw.match(/(\d{2}):(\d{2})(?::(\d{2}))?/);
    return (
        !timeMatch ||
        (timeMatch[1] === '00' && timeMatch[2] === '00' && (!timeMatch[3] || timeMatch[3] === '00'))
    );
};

// Format a resolved model-property value the same way PrintText does, so dates
// shown in rich text / external HTML match print text. Only formats when
// `companyDetails` is provided (the display path) and the value is a bare
// date / datetime string; everything else is returned as-is.
export const formatModelDateValue = (value, companyDetails) => {
    if (!companyDetails || typeof value !== 'string') return value;
    const raw = value.trim();
    if (!MODEL_DATE_RE.test(raw)) return value;

    let dateformat =
        companyDetails.data && companyDetails.data.companySettings
            ? companyDetails.data.companySettings.dateformat
            : '';
    dateformat = dateformat ? dateformat.toUpperCase() : '';

    if (isDateOnlyValue(raw)) {
        const DATE = moment(raw.split(/[ T]/)[0]);
        if (!DATE.isValid()) return value;
        return dateformat ? DATE.format(dateformat) : DATE.format('DD-MM-YYYY');
    }

    // DATETIME: stored as GMT -> convert to the company/local timezone.
    let DATE = moment(raw + ' GMT');
    const tz = companyDetails.data && companyDetails.data.timezone;
    if (tz && tz !== 'GMT') {
        const atz = tz.split('/').map(p => p[0] + p.slice(1).toLowerCase()).join('/');
        const localTz = momenttime.tz.guess();
        DATE = momenttime.tz(raw, atz).tz(localTz);
    }
    if (!DATE.isValid()) return value;
    return dateformat ? DATE.format(dateformat + ' hh:mm a') : DATE.format('DD-MM-YYYY hh:mm a');
};

// Remaining milliseconds for a countdown to `target` — consistent with how the
// value is displayed: a date-time target is a GMT instant, a date-only target
// is local midnight of that calendar date (NOT UTC midnight, which would be off
// by the timezone offset, e.g. +5:30).
export const getCountdownRemainingMs = (target) => {
    if (typeof target === 'string') {
        const raw = target.trim();
        if (MODEL_DATE_RE.test(raw) && isDateOnlyValue(raw)) {
            return moment(raw.split(/[ T]/)[0]).diff(moment());
        }
    }
    return moment.utc(target).diff(moment.utc());
};

